/* Voltx — theme.js
   Cart drawer (AJAX), mobile nav, quantity steppers, scroll reveal, PKR money. */
(function () {
  'use strict';

  var VX = window.VX || {};
  window.VX = VX;
  VX.settings = window.VXSettings || {};

  /* ---------- routes ---------- */
  var R = VX.settings.routes || {};
  var CART_JS = (R.cart || '/cart') + '.js';
  var CART_ADD = R.cart_add || '/cart/add.js';
  var CART_CHANGE = R.cart_change || '/cart/change.js';

  /* ---------- escaping ---------- */
  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  /* ---------- fetch response handling ---------- */
  function json(r) {
    if (!r.ok) {
      return r.json().catch(function () { return {}; }).then(function (b) {
        throw new Error(b.description || b.message || ('HTTP ' + r.status));
      });
    }
    return r.json();
  }

  /* ---------- money ---------- */
  VX.money = function (cents) {
    var n = Math.round((cents || 0) / 100);
    try { return '₨ ' + new Intl.NumberFormat('en-PK').format(n); }
    catch (e) { return '₨ ' + n.toLocaleString(); }
  };

  /* ---------- helpers ---------- */
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $all(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function lockScroll(lock) { document.documentElement.classList.toggle('no-scroll', lock); document.body.classList.toggle('no-scroll', lock); }

  /* ---------- overlay + drawers ---------- */
  var overlay = null;
  function ensureOverlay() {
    if (!overlay) {
      overlay = document.createElement('div');
      overlay.className = 'overlay';
      overlay.addEventListener('click', closeAll);
      document.body.appendChild(overlay);
    }
    return overlay;
  }
  function openDrawer(el) { if (!el) return; ensureOverlay().classList.add('is-open'); el.classList.add('is-open'); lockScroll(true); }
  function closeAll() {
    $all('.cart-drawer, .mobile-nav').forEach(function (d) { d.classList.remove('is-open'); });
    if (overlay) overlay.classList.remove('is-open');
    lockScroll(false);
  }
  VX.closeAll = closeAll;

  /* ---------- cart ---------- */
  VX.getCart = function () { return fetch(CART_JS, { headers: { 'Accept': 'application/json' } }).then(json); };

  VX.renderCart = function (cart) {
    // Clear any stale cart error banner on successful render
    var errorBox = $('[data-cart-error]');
    if (errorBox) errorBox.style.display = 'none';

    var countEls = $all('[data-cart-count]');
    countEls.forEach(function (el) { el.textContent = cart.item_count; el.style.display = cart.item_count > 0 ? 'flex' : 'none'; });

    var items = $('#cart-drawer-items');
    if (items) {
      if (!cart.items.length) {
        items.innerHTML = '<div class="text-center text-muted" style="padding:3rem 1rem">Your cart is empty.</div>';
      } else {
        items.innerHTML = cart.items.map(function (it) {
          var img = it.image ? it.image.replace(/(\.[a-z]+)(\?.*)?$/i, '_120x$1') : '';
          var variant = (it.options_with_values || []).filter(function (o) { return o.value !== 'Default Title'; })
            .map(function (o) { return o.value; }).join(' · ');
          return '' +
            '<div class="cart-item" data-key="' + it.key + '">' +
              '<img class="cart-item__img" src="' + img + '" alt="' + esc(it.product_title) + '" loading="lazy">' +
              '<div>' +
                '<div class="cart-item__title">' + esc(it.product_title) + '</div>' +
                (variant ? '<div class="cart-item__meta">' + esc(variant) + '</div>' : '') +
                '<div class="qty mt-2" data-key="' + it.key + '">' +
                  '<button data-qty="dec" aria-label="Decrease">–</button>' +
                  '<input type="text" value="' + it.quantity + '" inputmode="numeric" aria-label="Quantity">' +
                  '<button data-qty="inc" aria-label="Increase">+</button>' +
                '</div>' +
              '</div>' +
              '<div style="text-align:right">' +
                '<div class="price" style="font-size:0.95rem">' + VX.money(it.final_line_price) + '</div>' +
                '<button class="cart-item__remove text-muted" data-remove="' + it.key + '" style="font-size:0.78rem;margin-top:0.4rem;text-decoration:underline">Remove</button>' +
              '</div>' +
            '</div>';
        }).join('');
      }
    }
    var subtotal = $('[data-cart-subtotal]');
    if (subtotal) subtotal.textContent = VX.money(cart.total_price);

    // free shipping bar
    var bar = $('[data-free-ship]');
    if (bar && VX.settings.freeShippingThreshold) {
      var thr = VX.settings.freeShippingThreshold * 100;
      var pct = Math.min(100, (cart.total_price / thr) * 100);
      var fill = bar.querySelector('span'); if (fill) fill.style.width = pct + '%';
      var msg = $('[data-free-ship-msg]');
      if (msg) {
        var remain = thr - cart.total_price;
        msg.innerHTML = remain > 0 ? 'You are <strong>' + VX.money(remain) + '</strong> away from free shipping' : '🎉 You have unlocked <strong>free shipping</strong>';
      }
    }
  };

  VX.refresh = function (open) { return VX.getCart().then(function (c) { VX.renderCart(c); if (open) openDrawer($('.cart-drawer')); return c; }); };

  /* Surface a cart error message inside the drawer instead of failing silently. */
  VX.showCartError = function (message) {
    var host = $('#cart-drawer-items');
    if (!host) return;
    var box = host.parentNode && host.parentNode.querySelector('[data-cart-error]');
    if (!box) {
      box = document.createElement('div');
      box.setAttribute('data-cart-error', '');
      box.className = 'cart-error text-center';
      box.style.cssText = 'padding:0.75rem 1rem;color:#b00020;background:#fdecea;border-radius:4px;margin:0.5rem 1.25rem;font-size:0.85rem';
      if (host.parentNode) host.parentNode.insertBefore(box, host);
    }
    box.textContent = message;
    box.style.display = 'block';
    openDrawer($('.cart-drawer'));
  };

  VX.add = function (id, qty) {
    var btn = document.activeElement;
    return fetch(CART_ADD, {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: id, quantity: qty || 1 })
    }).then(json).then(function () { return VX.refresh(true); })
      .catch(function (e) { VX.showCartError(e.message || 'Could not add item to cart.'); })
      .then(function () { if (btn) btn.removeAttribute('disabled'); });
  };

  VX.change = function (key, qty) {
    return fetch(CART_CHANGE, {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(json).then(function (c) { VX.renderCart(c); return c; })
      .catch(function (e) { VX.showCartError(e.message || 'Could not update cart.'); });
  };

  /* ---------- delegated events ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-cart-open]');
    if (t) { e.preventDefault(); VX.refresh(true).catch(function (err) { VX.showCartError(err.message || 'Could not load cart.'); }); return; }
    var closer = e.target.closest('[data-cart-close], [data-mobile-close]');
    if (closer) {
      // Real navigation links must still navigate — only intercept buttons / placeholder links.
      var href = closer.getAttribute('href');
      if (closer.tagName === 'A' && href && href !== '#') { closeAll(); return; }
      e.preventDefault(); closeAll(); return;
    }
    var mob = e.target.closest('[data-mobile-open]');
    if (mob) { e.preventDefault(); openDrawer($('.mobile-nav')); return; }

    var add = e.target.closest('[data-add-to-cart]');
    if (add) {
      e.preventDefault();
      var id = add.getAttribute('data-add-to-cart');
      if (id) { add.setAttribute('disabled', 'true'); VX.add(id, 1).then(function () { add.removeAttribute('disabled'); }); }
      return;
    }
    var rem = e.target.closest('[data-remove]');
    if (rem) { e.preventDefault(); VX.change(rem.getAttribute('data-remove'), 0); return; }

    var qbtn = e.target.closest('[data-qty]');
    if (qbtn) {
      e.preventDefault();
      var wrap = qbtn.closest('.qty');
      var input = wrap.querySelector('input');
      var val = parseInt(input.value, 10) || 1;
      val = qbtn.getAttribute('data-qty') === 'inc' ? val + 1 : Math.max(0, val - 1);
      input.value = val;
      var key = wrap.getAttribute('data-key');
      if (key) VX.change(key, val);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });

  /* product-form (PDP) handled by product-form.js; listen for its submit */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[action*="/cart/add"]');
    if (form && form.hasAttribute('data-ajax-cart')) {
      e.preventDefault();
      var fd = new FormData(form);
      var btn = form.querySelector('[type="submit"]');
      if (btn) btn.setAttribute('disabled', 'true');
      fetch(CART_ADD, { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } })
        .then(json)
        .then(function () { return VX.refresh(true); })
        .catch(function (e) { VX.showCartError(e.message || 'Could not add item to cart.'); })
        .finally(function () { if (btn) btn.removeAttribute('disabled'); });
    }
  });

  /* ---------- scroll reveal ---------- */
  function initReveal() {
    var els = $all('[data-reveal]');
    if (!('IntersectionObserver' in window) || !els.length) { els.forEach(function (el) { el.classList.add('is-visible'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-visible'); io.unobserve(en.target); } });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- init ---------- */
  document.addEventListener('DOMContentLoaded', function () {
    initReveal();
    VX.getCart().then(VX.renderCart).catch(function () { /* silently ignore init-time cart load failures */ });
  });
})();
